export const IS_DEMO_MODE = true;
